import React, { useEffect, useState } from "react";
import { PdfModal } from "../ProductModal/components/PdfModal/PdfModal";
import { ProductModal } from "../ProductModal/ProductModal";
import { VideoModal } from "../VideoModal/VideoModal";

const PRODUCTS = require("../../products.json");
const VARIATIONS = require("../../variations.json");

const findProduct = (jsonList, model, country) => {
  return jsonList.find((product) => product.Model === model && product.Site === country);
};

function ModalContainerComponent({ vistaContent }) {
  const [variant, setVariant] = useState(null);
  const [product, setProduct] = useState(null);

  function toggleVistaAudio(state) {
    const audios = vistaContent.current.contentWindow.currentGlobalAudios;
    for (let audio in audios) {
      if (state === "ON") {
        audios[audio].audio.play();
      }
      if (state === "OFF") {
        audios[audio].audio.pause();
      }
    }
  }

  const [openVideo, setOpenVideo] = useState(false);
  function openVideoModal() {
    setOpenVideo(true);
    toggleVistaAudio("OFF");
  }
  function closeVideoModal() {
    setOpenVideo(false);
    toggleVistaAudio("ON");
  }

  const handleClose = () => {
    setVariant(null);
    setProduct(null);
    setOpenVideo(false);
    toggleVistaAudio("ON");
    setTwoDActive(true)
    setThreeDActive(false)
  };

  // Switch

  const [ twoDActive, setTwoDActive ] = useState(true)
  const [ threeDActive, setThreeDActive ] = useState(false)

  const toggleSwitch = () => {
    if(product.ViewerPath) {
      setTwoDActive(!twoDActive)
      setThreeDActive(!threeDActive)
    }
  }

  // PDF
  const [openPdf, setOpenPdf] = useState(false);
  function openPdfModal() {
    setOpenPdf(true);
  }

  function closePdfModal() {
    setOpenPdf(false);
  }

  useEffect(() => {
    function callback(e) {
      if (e.data.model) {
        const targetProduct = findProduct(PRODUCTS, e.data.model, e.data.country);
        setProduct(targetProduct);
      }
    }
    window.addEventListener("message", callback);

    return () => {
      window.removeEventListener("message", callback);
    };
  }, []);

  return (
    <>
      {openVideo && <VideoModal closeVideoModal={closeVideoModal} selectedProduct={variant || product} />}
      {openPdf && <PdfModal closePdfModal={closePdfModal} selectedProduct={product} />}
      <ProductModal
        handleClose={handleClose}
        openVideoModal={openVideoModal}
        selectedProduct={product}
        setVariant={setVariant}
        variationOptions={findProduct(VARIATIONS, product?.Model, product?.Site)?.Variations || []}
        openPdfModal={openPdfModal}
        closePdfModal={closePdfModal}
        openPdf={openPdf}
        toggleSwitch={toggleSwitch}
        twoDActive={twoDActive}
        threeDActive={threeDActive}
      />
    </>
  );
}

const ModalContainer = React.memo(ModalContainerComponent);

export { ModalContainer, findProduct };
